import { SearchOutlined } from "@mui/icons-material";
import { FormControl, Grid, InputAdornment, TextField } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import useDebounce from "../hooks/useDebounce";

const SearchableContent = ({ children, className }: any) => {
  const [searchString, setSearchString] = useState("");
  const contentRef = useRef<HTMLTableElement>(null);
  const searchTimeoutRef = useRef<number | undefined>(undefined);

  const handleKeyPress = (e: KeyboardEvent) => {
    if (e.key.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey) {
      if (searchTimeoutRef.current) {
        window.clearTimeout(searchTimeoutRef.current);
      }
      setSearchString((s) => s + e.key);
      searchTimeoutRef.current = window.setTimeout(() => {
        setSearchString("");
      }, 1000); // Resets search string after 1 second of inactivity
    }
  };

  const scrollToMatch = () => {
    const table = contentRef.current;
    if (table && searchString) {
      // Remove existing highlights
      const existingHighlights = table.getElementsByClassName("highlight");
      while (existingHighlights.length) {
        existingHighlights[0].classList.remove("highlight");
      }

      const regex = new RegExp("^" + searchString, "i");
      const cells = Array.from(table.getElementsByClassName(className));
      const matchingCell = cells.find((cell) =>
        regex.test(cell.textContent || ""),
      );

      if (matchingCell) {
        matchingCell.classList.add("highlight");
        matchingCell.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "center",
        });
      }
    }
  };

  useDebounce(
    () => {
      if (searchString) {
        scrollToMatch();
      }
    },
    500,
    [searchString],
  );
  // useEffect(() => {
  //   if (searchString) {
  //     scrollToMatch();
  //   }
  // }, [searchString]);

  useEffect(() => {
    window.addEventListener("keypress", handleKeyPress);
    return () => {
      window.removeEventListener("keypress", handleKeyPress);
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, []);

  return (
    <div ref={contentRef}>
      {searchString ? (
        <Grid
          item
          sx={{
            position: "fixed",
            top: "100px",
            right: "10px",
            zIndex: 80000000,
            background: "white",
          }}
          xs={12}
        >
          <FormControl fullWidth variant="outlined" size="small">
            <TextField
              id="input-with-icon-textfield"
              label={"Search Name"}
              variant="outlined"
              size="small"
              name="searchName"
              value={searchString}
              // onChange={(e) => setSearch(e.target.value)}
              placeholder={"Search Name"}
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchOutlined />
                  </InputAdornment>
                ),
              }}
            />
          </FormControl>
        </Grid>
      ) : (
        <></>
      )}
      {children}
    </div>
  );
};

export default SearchableContent;
